module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAFRJREFUKBVjYKAa+A8EIMOYkE3EzUFWxQDTCxNkRBeASWDQeBWiS6K4Bt0ovJLkOwivsXgl0R0I54O8BQJwATQGeaYCDSFbI/HBg+ZUnFyIDweTHwHmOy/qPyaKFwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_add.png
// module id = 74
// module chunks = 170